import { render, staticRenderFns } from "./monitorCCBList.vue?vue&type=template&id=d89a3006&scoped=true&"
import script from "./monitorCCBList.vue?vue&type=script&lang=js&"
export * from "./monitorCCBList.vue?vue&type=script&lang=js&"
import style0 from "./monitorCCBList.vue?vue&type=style&index=0&id=d89a3006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a3006",
  null
  
)

export default component.exports